import React from "react"
import Showcase from "../components/Showcase"
import { Window, View, Text, Carousel, Image } from "react-ame-components"

export class CarouselExample extends React.Component {
  state = {
    option1Checked: true,
    option2Checked: false,
  }
  render() {
    return (
      <Showcase
        centerGrid
        title="Componente Carousel"
        description="Este componente mostra imagens com efeito 'carrossel'">
        <View align="center">
          <Carousel>
            <View
              borderColor="support-01"
              borderWidth="thick"
              width="auto">
              <Image src="https://picsum.photos/seed/2/500/270" />
            </View>
            <View
              borderColor="support-01"
              borderWidth="thick"
              width="auto">
              <Image src="https://picsum.photos/seed/3/500/270" />
            </View>
            <View
              borderColor="support-01"
              borderWidth="thick"
              width="auto">
              <Image src="https://picsum.photos/seed/4/500/270" />
            </View>
            <View
              borderColor="support-01"
              borderWidth="thick"
              width="auto">
              <Image src="https://picsum.photos/seed/7/5000/270" />
            </View>
          </Carousel>
        </View>
      </Showcase>
    )
  }
}
